export default "__VITE_ASSET__pOYt90ye__"